/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { Button, Popover } from '@pmi/dsm-react';
import {
  ChevronDownSolidIcon,
  ChevronUpSolidIcon,
} from '@pmi/dsm-react/dist/components/icons';
import { useLayoutEffect, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { CartIcon } from '@pmi/dsm-react/dist/components/icons/fa/16';
import LogoMobile from '../../../logo-mobile.svg?react';
import Logo from '../../../logo.svg?react';
import { reportLinkClick } from '../../analytics';
import { getMyPMISiteUrl } from '../../env-vars';
import { getLinkModule } from '../../helpers';
import useLogout from '../../hooks/useLogout';
import useUser from '../../hooks/useUser';
import { resetVisibility, toggleVisibility } from '../Navigation/apiSlice';
import { useGetProfileImageUrlQuery } from './apiSlice';
import styles from './header.module.scss';
import AuthService from '../../services/AuthService';
import { userSelector } from '../../store/shared/userSlice';
import { ProfileImage, ProfileName } from '../ProfileName';
import { cartSelector, openCart } from '../../store/shared/cartSlice';
import { useGetProductsQuery } from '../../../Hub/TrainingHub/apiSlice';
import useUrlSearchParams from '../../hooks/useUrlSearchParams';

export default function Header() {
  const user = useUser();
  const logout = useLogout();
  const location = useLocation();
  const urlSearchParams = useUrlSearchParams();
  const tokenInQueryParam = urlSearchParams.get('token')?.length > 0 || false;
  const dispatch = useDispatch();

  const [profilePopoverToggleState, setProfilePopoverToggleState] =
    useState<boolean>(false);
  const pmiSiteUrl = getMyPMISiteUrl();
  const linkModule = getLinkModule();

  const authService = new AuthService();
  const { isLoaded } = useSelector(userSelector);
  const isHub = window.location.pathname.startsWith('/hub/');
  const { badgeCount } = useSelector(cartSelector);
  const displayBadgeCount = badgeCount > 9 ? '9+' : badgeCount;

  const { accountId } = useParams<{ accountId: string }>();

  const { data: profileImageUrl } = useGetProfileImageUrlQuery(null, {
    skip: !user || tokenInQueryParam,
  });

  const { data: userProducts } = useGetProductsQuery(
    {
      accountId,
    },
    {
      skip:
        !isHub ||
        !accountId ||
        !user?.b2b_aid ||
        !user?.b2b_auid ||
        user?.b2b_aid.toLocaleUpperCase() !== accountId.toLocaleUpperCase(),
    },
  );

  const showCart = isHub && userProducts?.showPayByUserCart;

  const toggleSideNav = (e: any) => {
    e.preventDefault();
    dispatch(toggleVisibility());
  };

  useLayoutEffect(() => {
    const callReset = () => {
      dispatch(resetVisibility());
    };
    window.addEventListener('resize', callReset);
    window.addEventListener('orientationchange', callReset);
    return () => {
      window.removeEventListener('resize', callReset);
      window.removeEventListener('orientationchange', callReset);
    };
  }, []);

  const handleLogout = async () => {
    await logout();
  };

  const ProfilePopoverContent = (
    <div className="display-flex flex-column">
      <div className="py-1 border-bottom px-3">
        <div className="d-flex align-items-center py-3">
          <ProfileImage url={profileImageUrl?.url ?? ''} />
          <ProfileName user={user} navigateToMyPmi />
        </div>
      </div>
      <div className="py-2 px-3">
        <div className="py-1">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleLogout().then();
            }}
            className={styles.profileMenuItemText}
          >
            Logout
          </a>
        </div>
      </div>
    </div>
  );

  const renderCart = (isDesktop?: boolean) => (
    <button
      className="cart-icon d-flex align-items-center me-4"
      id="btn-show-cart"
      type="button"
      onClick={() => {
        dispatch(openCart());
      }}
    >
      {isDesktop && (
        <span className="typography16 fw-bold gray800 ms-2">Cart</span>
      )}
      <div className={styles.iconWrapper}>
        <CartIcon className={styles.icon} />
        {badgeCount > 0 && (
          <span className={styles.badge}>{displayBadgeCount}</span>
        )}
      </div>
    </button>
  );

  const renderButton = () => (
    <Button
      size="xs"
      variant="outline-secondary"
      titleText="Login"
      onClick={() => authService.login(location.pathname + location.search)}
      className="me-3"
    />
  );

  const renderMobileNavbar = () => (
    <Navbar
      data-testid="sidebar-toggler-mobile"
      expand="lg"
      className={`d-md-none d-block me-2 px-3 ${styles.navItemToggleSidebar}`}
    >
      <Nav.Item onClick={toggleSideNav} className="me-auto position-relative">
        <span className="navbar-toggler-icon text-dark cursor-pointer" />
      </Nav.Item>
    </Navbar>
  );

  const renderDesktopNavBar = () => (
    <div className="d-flex dsm">
      {showCart && renderCart(true)}
      <ProfileImage url={profileImageUrl?.url ?? ''} />
      <Popover
        placement="bottom-end"
        content={ProfilePopoverContent}
        theme="light"
        className={styles.profileMenuPopover}
        onToggle={(state) => {
          setProfilePopoverToggleState(state);
        }}
      >
        <div className="d-flex align-items-center">
          <ProfileName user={user} />
          {!profilePopoverToggleState && (
            <ChevronDownSolidIcon className="ms-1" fontSize="sm" />
          )}
          {profilePopoverToggleState && (
            <ChevronUpSolidIcon className="ms-1" fontSize="sm" />
          )}
        </div>
      </Popover>
    </div>
  );

  const renderContent = (isDesktop: boolean) => {
    if (!isLoaded) return null;
    if (!user) return renderButton();
    return isDesktop ? renderDesktopNavBar() : renderMobileNavbar();
  };

  return (
    <header
      data-adoberegion={linkModule}
      data-testid="main-header"
      className={`${styles.mainHeader} print-hidden`}
    >
      {/* desktop header */}
      <div className="d-none d-md-flex justify-content-between px-4">
        <div>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <a
            href={pmiSiteUrl}
            className={`d-block ${styles.fullLogo}`}
            onClick={() => reportLinkClick('PMI Logo', pmiSiteUrl, linkModule)}
          >
            <Logo className="w-100 h-100" />
          </a>
        </div>
        {renderContent(true)}
      </div>

      {/* mobile header */}
      <div className="d-flex d-md-none justify-content-between align-items-center position-relative">
        {showCart && renderCart(false)}

        <div>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <a
            href={pmiSiteUrl}
            className={`d-block ${styles.smallLogo}`}
            onClick={() => reportLinkClick('PMI Logo', pmiSiteUrl, linkModule)}
          >
            <LogoMobile className="w-100 h-100" />
          </a>
        </div>
        <div className="">{renderContent(false)}</div>
      </div>
    </header>
  );
}
